import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardReconnectChart({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-[#bceda6] font-robo'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
        <p className='font-bold text-3xl text-center mt-4'>Reconnect IRS Forms!</p>
        <div className='flex flex-col items-center gap-4 mt-10'>
          <p>Based on our records, your IRS Authorization Form have been rejected for the following reason:</p>
          <p className='font-bold'>{customerData.customerLeadData.leadContact.chartStatusDescription}</p>
          <p>Please click the button below to reconnect your IRS Authorization Form.</p>
          <button onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}?isReconnect=1`) }} className='bg-blue-500 hover:bg-blue-600 transition duration-200 w-52 h-12 rounded-lg text-white'>
            Connect IRS Documents
          </button>
        </div>
      </div>
    </div>
  )
}